var indexOf = [].indexOf;

angular.module('shared').directive('contactSearch', function() {
  return {
    restrict: 'AE',
    scope: {
      onSelect: '=',
      onRemove: '=',
      allContacts: '=',
      types: '=',
      placeholder: '@',
      forBooking: '=',
      excludeProspects: '=',
      withPaymentMethod: '=',
      displaySelected: '=',
      selectedContacts: '=',
      rollCallId: '=',
      eventId: '=',
      displaySearchIcon: '='
    },
    template: require('templates/shared/contact_search.html.slim'),
    link: function($scope, element) {
      return element.bind('keydown', $scope.onKeyDown);
    },
    controller: ["$scope", "$state", "$stateParams", "$timeout", "$q", "Restangular", "ContactBadgeService", function($scope, $state, $stateParams, $timeout, $q, Restangular, ContactBadgeService) {
      var Contacts;
      $scope.selectedTags = $scope.selectedContacts ? $scope.selectedContacts : [];
      $scope.params = {};
      $scope.isFocused = false;
      $scope.setFocused = function(val) {
        $scope.isFocused = val;
        if (!val) {
          return $timeout(function() {
            return $scope.params.search = '';
          }, 100);
        }
      };
      Contacts = (function() {
        switch (false) {
          case !$scope.forBooking:
            return Restangular.one('gyms', $stateParams.gymId).all('contacts').all('for_booking');
          case !$scope.excludeProspects:
            return Restangular.one('gyms', $stateParams.gymId).all('contacts').all('exclude_prospects');
          case !$scope.rollCallId:
            return Restangular.one('gyms', $stateParams.gymId).one('roll_call', $scope.rollCallId).all('contact_search');
          default:
            return Restangular.one('gyms', $stateParams.gymId).all('contacts');
        }
      })();
      $scope.loadContacts = function(str) {
        var deferred, params;
        deferred = $q.defer();
        params = (function() {
          switch (false) {
            case !$scope.rollCallId:
              return {
                contact_search: str
              };
            case !$scope.allContacts:
              return {
                all_contacts_search: str
              };
            default:
              return {
                search: str
              };
          }
        })();
        if ($scope.eventId) {
          params.event_id = $scope.eventId;
        }
        Contacts.getList(params).then(function(contacts) {
          if ($scope.types) {
            contacts = _.filter(contacts, function(contact) {
              var ref;
              return ref = contact.type, indexOf.call($scope.types, ref) >= 0;
            });
          }
          contacts.forEach(function(contact) {
            contact.name = `${contact.first_name} ${contact.last_name}`;
            if ($scope.rollCallId) {
              contact.id = contact.contact_id;
              contact.name = contact.contact_name;
              contact.type = contact.contact_type.toLowerCase();
              return contact.status = contact.contact_status;
            }
          });
          return deferred.resolve(contacts);
        });
        return deferred.promise;
      };
      $scope.doSearch = _.debounce((function(str) {
        if (!str) {
          return;
        }
        $scope.isLoading = true;
        return $scope.loadContacts(str).then(function(contacts) {
          $scope.activeIndex = 0;
          $scope.collection = contacts;
          return $scope.isLoading = false;
        });
      }), 500);
      $scope.onKeyDown = function(event) {
        var ref, ref1;
        if (!$scope.isFocused) {
          return;
        }
        switch (event.which) {
          case 38:
            if ($scope.activeIndex > 0) {
              $scope.activeIndex = $scope.activeIndex - 1;
              event.preventDefault();
            }
            break;
          case 40:
            if ($scope.activeIndex < ((ref = $scope.collection) != null ? ref.length : void 0) - 1) {
              $scope.activeIndex = $scope.activeIndex + 1;
              event.preventDefault();
            }
            break;
          case 13:
            if ((ref1 = $scope.collection) != null ? ref1[$scope.activeIndex] : void 0) {
              $scope.selectContact($scope.collection[$scope.activeIndex]);
            }
        }
        return $scope.$apply();
      };
      $scope.getContactBadge = function(type, status) {
        return ContactBadgeService.get(type, status);
      };
      $scope.selectContact = function(contact) {
        $scope.params.search = '';
        return $scope.onSelect(contact);
      };
      $scope.onTagAdded = function(contact) {
        if ($scope.selectedTags.length > 1) {
          $scope.selectedTags.splice(0, 1);
        }
        return $scope.onSelect(contact);
      };
      $scope.onTagRemoved = function() {
        return $scope.onRemove();
      };
      return $scope.onBlur = function() {
        return $timeout(function() {
          return $scope.setFocused(false);
        }, 300);
      };
    }]
  };
});
